import script from "./manage_partner.vue?vue&type=script&setup=true&lang=js"
export * from "./manage_partner.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__